import { invariant } from '@epic-web/invariant'
import { useRootLoaderData } from '#app/root.tsx'
import { type AppRequestInfo } from './get-request-info'

/**
 * @returns the request info from the root loader
 */
export function useRequestInfo(): AppRequestInfo {
	const { requestInfo } = useRootLoaderData()
	
	if (!requestInfo) {
		// Fallback for when root loader data is not available
		console.warn('Root loader data not available, using fallback request info')
		return {
			origin: 'http://localhost:3000',
			path: '/signup',
			session: {
				theme: null,
				userId: null,
			},
			hints: { theme: 'light', timeZone: 'UTC' },
			userPrefs: { theme: null, sidebar: null },
		} as AppRequestInfo
	}
	
	invariant(requestInfo, 'No requestInfo found in root loader')
	return requestInfo as AppRequestInfo
}

export function useOptionalRequestInfo(): AppRequestInfo | undefined {
	const { requestInfo } = useRootLoaderData()
	return requestInfo as AppRequestInfo | undefined
}
